import React from "react";

const NailExtensionInJakkurDesign = () => {
  return (
    <div className="hairSalonInSahakaraWhat">
      <h3>Custom Nail Designs to Suit Every Style </h3>
      <p>
        One of the most exciting aspects of nail extensions near Jakkur is the
        opportunity to get creative. At SCENT, our talented nail artists love
        bringing your ideas to life. Whether you’re into timeless French tips or
        bold, intricate designs, our team is ready to make your vision a
        reality. Popular styles include:
      </p>
      <li>
        <h6>French Tips</h6>
        <p>
          Classic, chic, and always in style, French tips are versatile and can
          be customized with color or glitter for a modern twist.
        </p>
      </li>
      <li>
        <h6>Ombre Nails</h6>
        <p>
          For a trendy look, try ombre nails that feature a smooth gradient of
          colors, from neutral tones to vibrant hues.
        </p>
      </li>
      <li>
        <h6> Glitter and Embellishments</h6>
        <p>
          Add sparkle to your nails with glitter, rhinestones, or metallic
          accents that catch the light beautifully.
        </p>
      </li>{" "}
      <li>
        <h6>Floral and Artistic Designs</h6>
        <p>
          Express your personality with detailed floral designs or custom
          patterns created by our skilled nail artists.
        </p>
      </li>
    </div>
  );
};

export default NailExtensionInJakkurDesign;
